"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCampaignsEndpointRequest = exports.CampaignSortOption = void 0;
var CampaignSortOption;
(function (CampaignSortOption) {
    CampaignSortOption["Id"] = "id";
    CampaignSortOption["Reduction"] = "reduction";
    CampaignSortOption["StartAt"] = "start_at";
    CampaignSortOption["EndAt"] = "end_at";
})(CampaignSortOption || (exports.CampaignSortOption = CampaignSortOption = {}));
function createCampaignsEndpointRequest(parameters = {}) {
    return {
        method: 'GET',
        endpoint: 'campaigns',
        params: Object.assign(Object.assign(Object.assign(Object.assign({}, (parameters.sort && parameters.sort.by
            ? { sort: parameters.sort.by }
            : undefined)), (parameters.sort && parameters.sort.direction
            ? { sortDir: parameters.sort.direction }
            : undefined)), (parameters.pagination && parameters.pagination.page
            ? { page: parameters.pagination.page }
            : undefined)), (parameters.pagination && parameters.pagination.perPage
            ? { perPage: parameters.pagination.perPage }
            : undefined)),
    };
}
exports.createCampaignsEndpointRequest = createCampaignsEndpointRequest;
